import React, { useState, useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Spin } from "antd";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { useLazyGetLiftReportQuery } from "../../../redux/reports/reportsAPI";
import {
	updateReportResetCascaderPage,
	updateFilterCascaderTypeList,
	updateFilterUseCustomSearch,
	updateFilterType,
} from "../../../redux/reports/reportsSlice";
// COMPONENTS
import ReportsTable2 from "../ReportsTable2";
import ReportsHeader from "../ReportsHeader";
import ReportsFilterDrawer from "../ReportsFilterDrawer";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";

const ReportCarUsagePage = () => {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();
	const LEVEL = 5;
	const DEFAULT_COLUMNS = [
		"created_at",
		"org_name",
		"server_name",
		"bank_name",
		"lift_name",
		"type",
		"short_msg",
		"message",
	];
	const DEFAULT_OFFSETS = [
		"CARCALL",
		"FREIGHT DOWN CALL ASSIGNED TO CAR",
		"FREIGHT FRONT DOWN CALL",
		"FREIGHT FRONT UP CALL",
		"FREIGHT REAR UP CALL",
		"REARCARCALL",
		"FREIGHT REAR DOWN HALL ASSIGNED TO CAR",
		"FREIGHT REAR DOWN CALL",
		"STATUS",
	];
	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [loadPage, setLoadPage] = useState(false);

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { permissions } = useSelector((state: any) => state.user);
	const { theme } = useSelector((state: any) => state.home);
	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const [triggerGetReport, { data, isLoading, isError, isFetching }] =
		useLazyGetLiftReportQuery();

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const launchLoadPage = () => {
		setLoadPage(true);
		dispatch(updateReportResetCascaderPage(true));
		setTimeout(() => {
			setLoadPage(false);
			dispatch(updateReportResetCascaderPage(false));
		}, 500);
	};
	// ************************************************* */
	// USE EFFECT ************************************** */
	useEffect(() => {
		launchLoadPage();
		dispatch(updateFilterCascaderTypeList(DEFAULT_OFFSETS));
		dispatch(updateFilterType("Organizations"));
		dispatch(
			updateFilterUseCustomSearch({
				useCustomSearch: true,
				type: "Organizations",
				value: "",
				showSelect: true,
			})
		);
	}, []);
	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Spin spinning={loadPage}>
			{validatePermission("car-report", permissions) ? (
				<div className={`layout__contentPage__${theme}`}>
					<ReportsFilterDrawer
						level={LEVEL}
						disabledLevelSelect={false}
						filterManagement={{
							advanceFilters: true,
							exclusions: false,
							offsets: false,
							showOffsets: true,
						}}
						defaultOffsets={DEFAULT_OFFSETS}
						getDataWhenOpen={{ getDataWhenOpen: false, level: 0 }}
						showDatePicker
						showTypeSelect={false}
					/>
					<ReportsHeader
						level={LEVEL}
						disabledLevelSelect={false}
						downloadReport={false}
						getDataWhenOpen={{ getDataWhenOpen: false, level: 0 }}
						infoDescriptionText='report.infoDescriptionText1'
						showDatePicker
					/>
					<ReportsTable2
						defaultColumns={DEFAULT_COLUMNS}
						downloadReportData={{
							name: "carUsageReport",
							serviceName: "",
						}}
						response={data}
						triggerGetReport={triggerGetReport}
						isLoading={isLoading}
						isFetching={isFetching}
						isError={isError}
						useFilterTarget
					/>
				</div>
			) : (
				<UnauthorizedPage />
			)}
		</Spin>
	);
};

export default ReportCarUsagePage;
